import React from "react";
import { FormattedDate, FormattedMessage } from "react-intl";

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle
} from "src/common/components/Card";
import { TextPage } from "src/common/components/Page";
import { TextDoc } from "src/common/components/TextDoc";
import { useRelevantChanges } from "src/features/changelog/changes/hooks";
import { genericMessages } from "src/messages/generic";

export const Changelog: React.FunctionComponent = () => {
	const changes = useRelevantChanges();
	return (
		<TextPage>
			<Card>
				<CardHeader>
					<CardTitle>
						<FormattedMessage {...genericMessages.changes} />
					</CardTitle>
				</CardHeader>
				<CardContent>
					{changes.map(({ date, content: Content }) => (
						<TextDoc key={date}>
							<h1>
								<FormattedDate
									value={date}
									year="numeric"
									month="numeric"
									day="numeric"
								/>
							</h1>
							<Content />
						</TextDoc>
					))}
				</CardContent>
			</Card>
		</TextPage>
	);
};
